import { combineReducers } from 'redux'

import app from 'App/duck/reducers'
import account from 'features/account/reducers'
import userSettings from 'features/account/settings/duck/reducers'
import adyen from 'features/adyen/duck/reducers'
import applePay from 'features/applePay/duck/reducers'
import bankTransfer from 'features/bankTransfer/duck/reducers'
import cart from 'features/cart/cart-overview/duck/reducers'
import cartPRA from 'features/cart/pra/duck/reducers'
import checkout from 'features/checkout/duck/reducers'
import cybersource from 'features/cybersource/duck/reducers'
import favourites from 'features/favourites/duck/reducers'
import header from 'features/header/duck/reducers'
import klarna from 'features/klarna/duck/reducers'
import login from 'features/login/duck/reducers'
import myProfile from 'features/myProfile/duck/reducers'
import notifications from 'features/notifications/duck/reducers'
import orderTotals from 'features/orderTotals/duck/reducers'
import paypal from 'features/paypal/duck/reducers'
import publicProfile from 'features/publicProfile/duck/reducers'
import newPaymentMethodIndia from 'features/razorpay/duck/reducers'
import register from 'features/register/duck/reducers'
import returns from 'features/returns/duck/reducers'
import styleboard from 'features/Styleboard/styleboard-overview/duck/reducers'
import unrevieweds from 'features/UnreviewedProducts/duck/reducers'
import cartUSPBanner from 'features/usp/duck/reducers'
import vouchers from 'features/vouchers/duck/reducers'

import { RootState } from './types'

const reducers = combineReducers<RootState>({
  account,
  app,
  applePay,
  cart,
  cartPRA,
  cartUSPBanner,
  userSettings,
  adyen,
  checkout,
  favourites,
  myProfile,
  publicProfile,
  vouchers,
  notifications,
  klarna,
  login,
  register,
  paypal,
  header,
  orderTotals,
  styleboard,
  bankTransfer,
  cybersource,
  returns,
  unrevieweds,
  newPaymentMethodIndia,
})

export default reducers
